import React, { Component } from 'react';
import { Select } from 'antd';
import _ from 'i18n';

const { Option } = Select;

const monthLabels = [
  _('JANUARY'),
  _('FEBRUARY'),
  _('MARCH'),
  _('APRIL'),
  _('MAY'),
  _('JUNE'),
  _('JULY'),
  _('AUGUST'),
  _('SEPTEMBER'),
  _('OCTOBER'),
  _('NOVEMBER'),
  _('DECEMBER')
];

class MonthFilterContribution extends Component {

  getDynamicMonths = () => {
    const { year } = this.props;

    const currentYear = parseInt(year, 10);
    const prevYear = currentYear - 1;

    const months = [];

    // Add previous year: October → December
    for (let m = 10; m <= 12; m++) {
      const monthValue = m.toString().padStart(2, '0');
      months.push({
        value: `${prevYear}-${monthValue}`,
        label: `${monthLabels[m - 1]} ${prevYear}`
      });
    }

    // Add current year: January → December
    for (let m = 1; m <= 12; m++) {
      const monthValue = m.toString().padStart(2, '0');
      months.push({
        value: `${currentYear}-${monthValue}`,
        label: `${monthLabels[m - 1]} ${currentYear}`
      });
    }

    return months;
  };

  render() {
    const { startMonth, endMonth, handleStartMonthChange, handleEndMonthChange } = this.props;
    const dynamicMonths = this.getDynamicMonths();

    return (
      <div className={"flex items-center"} style={{ justifyContent: "flex-end" }}>
        <div className={"mr-2"}>
          <span className={" compare-stats-filters-font mr-2"}>{_('START_MONTH')}</span>
          <Select style={{ width: 200 }} onChange={handleStartMonthChange} value={dynamicMonths.find(m => m.value === startMonth) ? startMonth : dynamicMonths[0].value}>
            {dynamicMonths.map(({ value, label }) => (
              <Option key={value} value={value}>{label}</Option>
            ))}
          </Select>
        </div>

        <div>
          <span className={"compare-stats-filters-font mr-2"}>{_('END_MONTH')}</span>
          <Select style={{ width: 200 }} onChange={handleEndMonthChange} value={dynamicMonths.find(m => m.value === endMonth) ? endMonth : dynamicMonths[dynamicMonths.length - 1].value}>
            {dynamicMonths.map(({ value, label }) => (
              <Option key={value} value={value}>{label}</Option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}

export default MonthFilterContribution;



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/CompareStats/MonthFilterContribution.js